export default __webpack_public_path__ + "static/media/certificado-1.3bffce38.webp";